import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from 'components/Icon';
import Text from 'components/Text';
import Flex from 'components/Flex';
import Stack from 'components/Stack';
import SimpleModal from 'components/SimpleModal';
import { useDeletePlaylistContent } from 'actions/playlists';
import { getAssetIcon } from 'utils/icons';
function ContentDeleteConfirmation(_ref) {
  var playlistId = _ref.playlistId,
    asset = _ref.asset,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isPlaylistLink = asset.type === 'playlist';
  var _useDeletePlaylistCon = useDeletePlaylistContent(playlistId, isPlaylistLink ? {
      successMessage: t('alert_playlist_link_removed_successfully'),
      errorMessage: t('alert_playlist_link_not_removed')
    } : {
      successMessage: t('alert_asset_removed_successfully'),
      errorMessage: t('alert_asset_not_removed')
    }),
    deleteAsset = _useDeletePlaylistCon.deletePlaylistContent,
    isLoading = _useDeletePlaylistCon.isLoading;
  function confirmDeletion() {
    deleteAsset(asset.id, {
      onSuccess: onClose
    });
  }
  return /*#__PURE__*/React.createElement(SimpleModal, {
    title: isPlaylistLink ? t('actions_remove_playlist_link') : t('actions_remove_asset'),
    body: /*#__PURE__*/React.createElement(Stack, {
      spacing: "s"
    }, isPlaylistLink ? t('modal_confirm_remove_playlist_link') : t('modal_confirm_remove_asset'), /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Icon, {
      name: getAssetIcon(asset)
    }), /*#__PURE__*/React.createElement(Text, {
      bold: true,
      ml: "xs",
      overflow: "wrap"
    }, asset.name))),
    buttons: [{
      label: t('actions_keep'),
      onClick: onClose,
      isDisabled: isLoading
    }, {
      label: t('actions_remove'),
      onClick: confirmDeletion,
      isDisabled: isLoading,
      variant: 'primary'
    }],
    onClose: onClose
  });
}
export default ContentDeleteConfirmation;